<template>
  <div ref="buttonSplit" class="split-button flex-center" :class="[hasBorderParent ? 'border-split-btn' : '']">
    <button
      ref="resize"
      class="btn flex-row primary-button"
      :class="[type, classCustom, hasBorder ? '' : 'btn-border-none']"
      :disabled="disabled"
      @click="$emit('primaryClick', $event)"
    >
      <div v-if="leftIcon" :class="['icon24 icon left', leftIcon]">&nbsp;</div>
      <div v-if="text" class="text" :class="[{'pl-0': leftIcon}]">
        {{ text }}
      </div>
    </button>
    <div class="button-line" />
    <menu-wrapper ref="wrapper" class="widget-more-container widget-btn" :class="[type]" :disabled="disabled">
      <template #menu-button="{toggleMenu}">
        <button
          class="widget-more"
          :class="[type, classCustom, hasBorder ? '' : 'btn-border-none']"
          :disabled="disabled"
          @click.prevent="toggleMenu"
        />
      </template>
      <template #menu-content>
        <div v-for="(item, index) in menuItems" :key="index">
          <div v-if="item.isTitle === true" class="title-group">
            <label class="label" :title="item.text">{{ item.text }}</label>
          </div>
          <menu-item
            v-else
            :seperator-bottom="item.seperatorBottom"
            :visible="item.visible"
            @menu-item-click="clickItem(item)"
          >
            {{ item.text }}
          </menu-item>
        </div>
      </template>
    </menu-wrapper>
  </div>
</template>
<script>
import {defineComponent, computed, ref, getCurrentInstance} from 'vue';
import MenuWrapper from '@/components/dropdown/MenuWrapper.vue';
import MenuItem from '@/components/dropdown/MenuItem.vue';
import ScrollParent from '@/commons/componentMixin.js';

export default defineComponent({
  name: 'MsSplitButton',
  components: {
    MenuWrapper,
    MenuItem,
  },
  props: {
    // Text hiển thị
    text: {
      defualt: null,
      type: String,
    },
    // Icon trái
    leftIcon: {
      default: null,
      type: String,
    },
    // Icon phải
    rightIcon: {
      default: 'chevron-down-white',
      type: String,
    },
    // Loại button gồm 3 loại primary/secondary/third/four để hiện thị style tương ứng
    type: {
      default: 'primary',
      type: String,
    },
    /**
     * Trạng thái button disabled
     */
    disabled: {
      default: false,
      type: Boolean,
    },
    /**
     * Danh sách các item của context menu
     */
    menuItems: {
      type: Array,
      default: new Array(),
    },
    /**
     * ĐVThi 18/02/2020
     * muốn đặt thêm stype cho lớp mục đích có cách để trên form tìm được đến control
     */
    classCustom: {
      default: '',
      type: String,
    },
    /**
     * NNLAM 26/02/2020
     * có cho phép tự custom vị trí dropdown menu hay không
     */
    customPositionMenu: {
      type: Boolean,
      default: false,
    },
    /**
     * NNLAM 26/02/2020
     * Set lại chiều dài menu dropdown
     */
    customWidth: {
      type: Number,
      default: 0,
    },
    /**
     * NNLAM 26/02/2020
     * khoảng cách của button so với lề trên/dưới
     */
    heightOffset: {
      type: Number,
      default: 5, // 25
    },
    /**
     * NNLAM 26/02/2021
     * khoảng cách của button so với lề trái/phải
     */
    widthOffset: {
      type: Number,
      default: 25,
    },
    /**
     * NNLAM 26/02/2021
     * Có show menu khi click vào icon right của button không, mặc định có
     */
    hasShowMenu: {
      type: Boolean,
      default: true,
    },
    /**
     * NNLAM 26/02/2021
     * Có tooltip cho btt không
     */
    tooltipText: {
      type: [String, Object],
      default: null,
    },
    // border hiển thị cho các button con
    hasBorder: {
      default: false,
      type: Boolean,
    },
    // border bên ngoài 2 button con
    hasBorderParent: {
      default: false,
      type: Boolean,
    },
  },
  setup(props, {emit}) {
    const {proxy} = getCurrentInstance();

    const clickItem = item => {
      emit('menuClick', item);
    };

    ScrollParent();

    function processScrollParent() {
      proxy.$refs.wrapper.closeHandler();
    }

    const toggleMenu = ref(false);
    // end -----------------------------------------------------------------------

    return {
      clickItem,
      toggleMenu,
      processScrollParent,
    };
  },
});
</script>

<style scoped lang="scss">
@import '@/assets/scss/components/MsButton.scss';

.split-icon {
  width: 36px;
  height: 24px;
  margin: 0 !important;
  .icon {
    margin: 0;
    cursor: pointer;
  }
}

.context-item {
  height: 36px;
  padding: 2px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  .context-text {
    padding: 0 8px;
  }
  &:hover {
    cursor: pointer;
    background: $hover-and-active-bg-control;
    color: #14aa8a;
  }
}
.context-icon {
  margin-right: 8px;
}
.color-red {
  color: #ff0000;
}
.button-line {
  display: inline-block;
  width: 1px;
  height: 60%;
  background-color: #fff;
}
button.widget-more {
  border-radius: 4px;
}
.split-button {
  border-radius: 3px;
  background-color: $primary;
  overflow: auto;
  &.border-split-btn {
    border: 1px solid #afafaf;
  }
  button {
    &.primary-button {
      border-end-end-radius: unset;
      border-start-end-radius: unset;
    }
  }
}

.title-group {
  margin: 8px 0px 6px 12px;
}
</style>
